export function changeAvatar(type, data){
    if(type === "user_avatar" ){
        const avatar = document.getElementById('main_avatar');
        const path = data.previews["user_avatar"].path;
        return avatar.style.backgroundImage = `url(/${path})`;
    }
}

export function changeToDefaultAvatar(type) {
    if(type === "user_avatar" ){
        const avatar = document.getElementById('main_avatar');
        const path = "/frontend/src/images/settings/default-avatar.png";
        return avatar.style.backgroundImage = `url(${path})`;
    }
}


// WEBPACK FOOTER //
// ./src/_app/clients-upload/avatar-changer.js